import { onMounted, onServerPrefetch } from 'vue';

export const useServerPrefetch = (fetchData: () => Promise<any>, data: any) => {
  onServerPrefetch(async () => {
    await fetchData();
  });

  onMounted(() => {
    if (data === null) {
      fetchData();
      console.warn('SSR数据预取失败，降级为CSR获取数据! \n ', fetchData.toString());
    }
  });
};
